exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".src-components-layout-AppLayout-app{text-align:center;min-height:100%;margin:0 auto -60px;padding:0 0 60px;background:#fff}.src-components-layout-AppLayout-login{background:#fff}", ""]);

// exports
exports.locals = {
	"app": "src-components-layout-AppLayout-app",
	"login": "src-components-layout-AppLayout-login"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"localIdentName":"[path][local]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/dist/cjs.js!./src/components/layout/AppLayout/styles.scss
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1,"modules":true,"localIdentName":"[path][local]"}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/dist/cjs.js!./src/components/layout/AppLayout/styles.scss
// module chunks = 1